import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Users from './user/pages/Users';
import UserProfile from './user/components/UserProfile';
import UserRegister from './user/components/UserRegister';
import Auth from './user/pages/Auth';
import MainNavigation from './shared/components/Navigation/MainNavigation';
import { AuthContext } from './shared/context/auth-context';

import { useAuth } from './shared/hooks/auth-hook';


const App = () => {
  const { token, login, logout, userId, userName, isRegistered, setIsRegistered } = useAuth();

  useEffect(() => {
    const checkProfile = async () => {
      if (!userId || !token) return;

      try {
        const response = await fetch(
          `http://localhost:5001/api/users/${userId}/profile`
        );

        setIsRegistered(response.ok);
      } catch (err) {
        setIsRegistered(false);
      }
    };

    checkProfile();
  }, [userId, token, setIsRegistered]);


  let routes;

  if (token) {
    routes = (
      <Switch>
        <Route path="/" exact>
          <Users />
        </Route>
        <Route path="/:userId/profile" exact>
          <UserProfile />
        </Route>
        <Route path="/:userId/register" exact>
          <UserRegister />
        </Route>
        <Redirect to="/" />
      </Switch>
    );
  } else {
    routes = (
      <Switch>
        <Route path="/" exact>
          <Users />
        </Route>
        <Route path="/:userId/profile" exact>
          <UserProfile />
        </Route>
        <Route path="/auth">
          <Auth />
        </Route>
        {/*<Redirect to="/auth" />*/}
        <Redirect to="/" />
      </Switch>
    );
  }


  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,

        userName: userName,
        
        isRegistered: isRegistered,
        setIsRegistered: setIsRegistered,

        login: login,
        logout: logout
      }}
    >
      <Router>
        <MainNavigation />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
        <main>{routes}</main>
      </Router>
    </AuthContext.Provider>
  );
};

export default App;
